import { render } from "./PropertyDetailView.vue?vue&type=template&id=98f461fa"
import script from "./PropertyDetailView.vue?vue&type=script&lang=js"
export * from "./PropertyDetailView.vue?vue&type=script&lang=js"

import "./PropertyDetailView.vue?vue&type=style&index=0&id=98f461fa&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__